export const dashboardEaBackgrounds = ['#ea0029', '#ff9015', '#ff6b00', '#ffb71b'];

export const dashboardElmBackgrounds = ['#ea0029', '#ff6b00', '#ff9015'];

export const elmByDivisionBackgrounds = ['#d12e30', '#ee6513', '#fb9312', '#fcc500', '#f6e324'];
